<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">
            {{ $t(`Your payment is currently processing, please wait!`) }}
          </div>
          <div class="loader" style="margin-top: 30px"></div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PaymentPendingPage",
  props: [],

  components: {},

  mounted() {
    if (!this.$route.query.order_id) {
      this.$router.replace({ name: "Home" });
      return;
    }

    this.checkStatus();
    this.interval = setInterval(this.checkStatus, 10000);
  },

  data: function () {
    return {
      interval: null,
    };
  },

  methods: {
    clearPolling() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    checkStatus() {
      const orderId = this.$route.query.order_id;
      if (!orderId) {
        this.handleCompletion("error");
        return;
      }

      this.$http
        .get("deposit/status", {
          params: { order_id: orderId },
        })
        .then(({ data }) => {
          if (data.status !== "OK") {
            this.handleCompletion("error");
            return;
          }

          if (data.order.redirect_url) {
            window.location = data.order.redirect_url;
            return;
          }

          const orderStatus = data.order.status;
          if (orderStatus && orderStatus !== "pending") {
            this.handleCompletion(orderStatus);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.clearPolling();
            this.$router.push({ name: "Home" });
            return;
          }

          this.handleCompletion("error");
        });
    },
    handleCompletion(status) {
      this.clearPolling();

      if (status === "success") {
        this.$router.push("/success-payment");
        return;
      }

      this.$router.push("/fail-payment");
    },
  },

  beforeUnmount() {
    this.clearPolling();
  },
});
</script>
